import { render, staticRenderFns } from "./ViewMatchingJob.vue?vue&type=template&id=747851ab&scoped=true"
import script from "./ViewMatchingJob.vue?vue&type=script&lang=ts"
export * from "./ViewMatchingJob.vue?vue&type=script&lang=ts"
import style0 from "./ViewMatchingJob.vue?vue&type=style&index=0&id=747851ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747851ab",
  null
  
)

export default component.exports